import { render, staticRenderFns } from "./worker-station.vue?vue&type=template&id=4850a667&scoped=true&"
import script from "./worker-station.vue?vue&type=script&lang=ts&"
export * from "./worker-station.vue?vue&type=script&lang=ts&"
import style0 from "./worker-station.vue?vue&type=style&index=0&id=4850a667&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850a667",
  null
  
)

export default component.exports